import React from "react"

export default class Heading extends React.Component {
    render(){
        const month = () => {
            var monthData = {
                0: "January",
                1: "February",
                2: "March",
                3: "April",
                4: "May",
                5: "June",
                6: "July",
                7: "August",
                8: "September",
                9: "October",
                10: "November",
                11: "December",
            }
            return monthData[this.props.date.month]
        }
        const week = () => {
            var weekData = {
                1: "Monday",
                2: "Tueday",
                3: "Wednesday",
                4: "Thursday",
                5: "Friday",
                6: "Saturday",
                7: "Sunday",
            }
            return weekData[this.props.date.weekDay]
        }  
        const timeOfDay = () => {
            if (this.props.date.hour < 12){
                return "Morning"
            } else if (this.props.date.hour >= 12 && this.props.date.hour < 18){
                return "Afternoon"
            } else if (this.props.date.hour >= 18){
                return "Evening"
            }
        }    
        const nightDay = (this.props.date.hour < 18) ? "Today" : "Tonight"

        return (
        <div className="title">
            <h1 className="greeting">
                Good {timeOfDay()}, <b id="location">{this.props.location}</b>.
            </h1>
            <h1 className="greeting">
                {nightDay} is {week()} {month()} {this.props.date.day}.
            </h1>
        </div>
        )
    }
}